export const dispatchDidUnmount = (vNode) => {
    if (vNode.type !== 'ELEMENT')
        return;
    vNode.children.forEach(dispatchDidUnmount);
    vNode.lifeEvents.didUnmount?.();
    vNode.lifeEvents.didUnmount = undefined;
};
